module.exports = __webpack_public_path__ + "img/img (42).86a888e8.jpg";